import type { RelativeDateRange } from '@hotjar/global-filters';
import { DATE_RANGE_TYPE, DATE_UNITS } from '@hotjar/global-filters';
import type { RelativeDateRangeOption } from '../lib/heatmapDateRangeConverter';

export enum RELATIVE_DATE_RANGE_LABELS {
  LAST_24_HOURS = 'Last 24 hours',
  LAST_7_DAYS = 'Last 7 days',
  LAST_15_DAYS = 'Last 15 days',
  LAST_30_DAYS = 'Last 30 days',
  LAST_3_MONTHS = 'Last 3 months',
  LAST_6_MONTHS = 'Last 6 months',
  LAST_12_MONTHS = 'Last 12 months',
}

export enum RELATIVE_DATE_RANGE_LABELS_SHORT {
  LAST_24_HOURS = '24h',
  LAST_7_DAYS = '7d',
  LAST_15_DAYS = '15d',
  LAST_30_DAYS = '30d',
  LAST_3_MONTHS = '3m',
  LAST_6_MONTHS = '6m',
  LAST_12_MONTHS = '12m',
}

export const DEFAULT_RELATIVE_DATE_RANGE_OPTION: RelativeDateRangeOption = {
  type: DATE_RANGE_TYPE.RELATIVE,
  label: RELATIVE_DATE_RANGE_LABELS.LAST_30_DAYS,
  amount: 30,
  unit: DATE_UNITS.DAYS,
  short: RELATIVE_DATE_RANGE_LABELS_SHORT.LAST_30_DAYS,
};

export const DEFAULT_RELATIVE_DATE_RANGE: RelativeDateRange = {
  type: DATE_RANGE_TYPE.RELATIVE,
  amount: 30,
  unit: DATE_UNITS.DAYS,
};

export const RELATIVE_DATE_RANGE_OPTIONS: RelativeDateRangeOption[] = [
  {
    type: DATE_RANGE_TYPE.RELATIVE,
    label: RELATIVE_DATE_RANGE_LABELS.LAST_24_HOURS,
    amount: 24,
    unit: DATE_UNITS.HOURS,
    short: RELATIVE_DATE_RANGE_LABELS_SHORT.LAST_24_HOURS,
  },
  {
    type: DATE_RANGE_TYPE.RELATIVE,
    label: RELATIVE_DATE_RANGE_LABELS.LAST_7_DAYS,
    amount: 7,
    unit: DATE_UNITS.DAYS,
    short: RELATIVE_DATE_RANGE_LABELS_SHORT.LAST_7_DAYS,
  },
  {
    type: DATE_RANGE_TYPE.RELATIVE,
    label: RELATIVE_DATE_RANGE_LABELS.LAST_15_DAYS,
    amount: 15,
    unit: DATE_UNITS.DAYS,
    short: RELATIVE_DATE_RANGE_LABELS_SHORT.LAST_15_DAYS,
  },
  DEFAULT_RELATIVE_DATE_RANGE_OPTION,
  {
    type: DATE_RANGE_TYPE.RELATIVE,
    label: RELATIVE_DATE_RANGE_LABELS.LAST_3_MONTHS,
    amount: 3,
    unit: DATE_UNITS.MONTHS,
    short: RELATIVE_DATE_RANGE_LABELS_SHORT.LAST_3_MONTHS,
  },
  {
    type: DATE_RANGE_TYPE.RELATIVE,
    label: RELATIVE_DATE_RANGE_LABELS.LAST_6_MONTHS,
    amount: 6,
    unit: DATE_UNITS.MONTHS,
    short: RELATIVE_DATE_RANGE_LABELS_SHORT.LAST_6_MONTHS,
  },
  {
    type: DATE_RANGE_TYPE.RELATIVE,
    label: RELATIVE_DATE_RANGE_LABELS.LAST_12_MONTHS,
    amount: 12,
    unit: DATE_UNITS.MONTHS,
    short: RELATIVE_DATE_RANGE_LABELS_SHORT.LAST_12_MONTHS,
  },
];
